/**
 * used to parse and render liquid files in JS
 * see: https://liquidjs.com/index.html
 * note: currently unable to use snippets that have a render tag
 */
import { Liquid } from 'liquidjs';
import { toMoney } from '../helpers/transformations';
const engine = new Liquid();
engine.plugin(moneyFilterPlugin);
export function getLiquidEngine() {
    return engine;
}
// we need to define any filters not found in the following: https://liquidjs.com/filters/overview.html
function moneyFilterPlugin() {
    this.registerFilter('money', (val) => toMoney(val, window?.UNTUCKitConfig?.cartCurrencySymbol, true));
}
